import React from 'react';

import { submittedEventData } from '../../types/Reigenspf001';
import { dateFormatter } from './dateFormatter';

/**
 * 申し込み済みのイベントを表示するコンポーネント
 * @param props イベント情報と過去のイベントであるかの真偽値
 * @returns
 */
export function SubmittedEvent (props: submittedEventData){
  //  時間のフォーマット変更
  //  開催日時（開始）
  const eventFromTime= formatTime(props.from_time)

  //  開催日時（終了）
  const eventToTime = formatTime(props.to_time)

   /**
   * 
   * @param date string型の時刻(hh:mm:ss)
   * @returns results [hh,mm,ss]
   */
   function formatTime(date: string){
    const result = date.split(':');

    return result
  }


  
  return (
    <div className="l-record">
      <div className="record-list">
        <div className="record-title-box">
          <h3 className="title">
            {props.event_type_id === '7' ||
              (props.event_type_id === '8' && (
                <div>
                  <i className={props.icon_class}></i>
                  <span className="txt">{props.subject}</span>
                </div>
              ))}
            {props.event_type_id !== '7' &&
              props.event_type_id !== '8' && (
                <a
                  href={`/detail?url=${props.url}`}
                  className="link-ic"
                >
                  {/* イベントの種別IDを元にイベント種別マスタからアイコンクラスを検索する */}
                  <i className={props.icon_class}></i>
                  <span className="txt">{props.subject}</span>
                </a>
              )}
          </h3>
        </div>
        <div className="record-set col1">
          <dl>
            <dt>開催日</dt>
            <dd>{dateFormatter(props.date)}</dd>
            
          </dl>
        </div>
        <div className="record-set col1">
          <dl>
            <dt>開催日時</dt>
            <dd>
            {eventFromTime[0]}:{eventFromTime[1]}～{eventToTime[0]}:{eventToTime[1]}
            </dd>
          </dl>
        </div>
        <div className="record-set col1">
          <dl>
            <dt>会場名</dt>
            <dd>{props.location}</dd>
          </dl>
        </div>
        <div className="record-set col1">
          <dl>
            <dt>主管部署</dt>
            <dd>
              {props.department_name}
            </dd>
          </dl>
        </div>

        <div className="record-set col1">
          <dl>
            <dt>会費</dt>
            <dd>{props.member_fee.toLocaleString()}円</dd>
          </dl>
        </div>
        <div className="record-set col1">
          <dl>
            <dt>参加状況</dt>
            <dd>
              {props.cancel_waiting_flag 
                ? 
                  'キャンセル待ち' 
                :
                props.join_flag ? '参加' : '不参加'}
              
            </dd>
          </dl>
        </div>
      </div>
    </div>
  );
}